/**
 * Sticky header that re-appears on scroll-up — WCAG 2.1 AAA aware.
 *
 * The header (already `position: sticky`) slides out of view while the user
 * scrolls down past it, and slides back in as soon as they scroll up, reach
 * the top of the page, or move keyboard focus into it. Keeping focused
 * elements visible avoids hiding a focused control from keyboard/AT users.
 */

const HIDDEN_CLASS = 'flip-header--hidden';

// Ignore tiny scroll deltas (trackpad jitter, mobile address-bar resize, etc.)
const SCROLL_THRESHOLD = 8;

export function initStickyHeader() {
  const header = document.querySelector('.flip-header');
  if (!header) return;

  let lastScrollY = window.scrollY;
  let ticking = false;

  function reveal() {
    header.classList.remove(HIDDEN_CLASS);
  }

  function update() {
    const currentScrollY = Math.max(window.scrollY, 0);
    const delta = currentScrollY - lastScrollY;
    const headerHeight = header.offsetHeight;

    if (currentScrollY <= headerHeight) {
      // Always show near the top of the page
      reveal();
    } else if (delta > SCROLL_THRESHOLD && !header.contains(document.activeElement)) {
      // Scrolling down — hide, but never while focus is inside the header
      header.classList.add(HIDDEN_CLASS);
    } else if (delta < -SCROLL_THRESHOLD) {
      // Scrolling up — reveal and let it stick
      reveal();
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  // Tabbing into the header (e.g. skip link, nav links) must reveal it —
  // a focused control should never be hidden off-screen.
  header.addEventListener('focusin', reveal);
}
